import { render, staticRenderFns } from "./WalletIcon.vue?vue&type=template&id=690d48ef"
import script from "./WalletIcon.vue?vue&type=script&lang=js"
export * from "./WalletIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports